import { FC } from 'react';
import { Loader } from '../../shared/components';

export const Loading: FC = () => {
    return (
        <div className="flex flex-col items-center justify-center h-screen w-fill bg-background-primary">
            <Loader width={500} animation="pulse" />
        </div>
    );
};
